import * as React from 'react';
import { EditState, BaseRouteProps } from '../../../interfaces';
import { ScoreCardGroup, ScoreCardGroupCharacteristic } from '../../../models';
import { ScoreCardGroupDataService } from '../../../services';
import { NavLink } from 'react-router-dom';
import { TopNavMenu } from '../../navigation/TopNavMenu';
import { ScoreCardGroupForm } from './ScoreCardGroupForm';
import { LoadingIndicator, PVAPage } from '../../../components';
import { UserStore } from '../../../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';

interface ScoreCardEditProps extends BaseRouteProps<{scoreCardId: number, groupId: number}> {
    UserStore?: UserStore;
}

interface ScoreCardEditState extends EditState<ScoreCardGroup> {
    loading: boolean;
}

@inject('UserStore') @observer
export class ScoreCardGroupEdit extends React.Component<ScoreCardEditProps, ScoreCardEditState> {
    private scoreCardGroupDataService = new ScoreCardGroupDataService(this.props.notificationService);

    @computed get userLanguage() {
        return this.props.UserStore!.userInfo.language;
    }

    constructor(props: ScoreCardEditProps) {
        super(props);

        this.state = {
            originalEntity: undefined,
            loading: false
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        const id = this.props.match.params.groupId;

        if (id) {
            this.scoreCardGroupDataService.get(id).then((scoreCardGroup: ScoreCardGroup) => {
                this.setState({ originalEntity: scoreCardGroup });
            }).catch((response) => {
                this.props.history.push({
                    pathname: '/error',
                    state: {
                        code: response.status,
                        entityType: 'score card group'
                    }
                });
            });
        }
    }

    public render() {
        if (!this.state.originalEntity || this.state.loading) {
            return <LoadingIndicator />;
        }

        return (
            <PVAPage>
                <TopNavMenu open={true} />

                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/scorecards/${this.props.match.params.scoreCardId}`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp; 
                        Edit Score Card Group
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <ScoreCardGroupForm defaultValues={this.state.originalEntity} submit={(e: any) => this.save(e)} />

                    <div className="row">
                        <div className="col-xs-8">
                            <h3>Characteristics</h3>
                        </div>
                        <div className="col-xs-4 text-right">
                            <NavLink className="btn btn-default" to={`/scorecardgroup/${this.props.match.params.groupId}/create`}>
                                Create
                            </NavLink>
                        </div>
                    </div>
                    <table className="table table-striped">
                        <tbody>
                            {this.state.originalEntity.scoreCardGroupCharacteristics.map((scgc: ScoreCardGroupCharacteristic, ind: number) => {
                                return <tr key={`fgc-${ind}`}>
                                    <td>{scgc.name}</td>
                                    <td className="text-right">
                                        <NavLink className="btn btn-default" to={`/scorecardgroup/${this.props.match.params.groupId}/${scgc.id}`}>
                                            Edit
                                        </NavLink>
                                    </td>
                                </tr>;
                            })}
                        </tbody>
                    </table>
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.scoreCardGroupDataService.update(values);
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCardGroup/ScoreCardGroupEdit.tsx